const features = [
  {
    title: '《暗夜追影》火热上线',
    tag: '动作悬疑',
    desc: '年度重磅动作悬疑大片，顶级制作团队倾力打造，高燃打斗与烧脑剧情完美融合，全网独家首发上线。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20scene%20with%20a%20mysterious%20figure%20in%20a%20long%20coat%20standing%20in%20a%20rainy%20neon-lit%20alley%20at%20night%2C%20film%20noir%20atmosphere%20with%20dramatic%20shadows%20and%20reflections%20on%20wet%20pavement%2C%20warm%20amber%20streetlights%20contrasting%20with%20cool%20blue%20neon%2C%20cinematic%20composition%20with%20letterbox%20aspect%20ratio&width=800&height=500&seq=carousel-1-91movie&orientation=landscape',
    alt: '暗夜追影专题推荐',
  },
  {
    title: '《星河恋人》浪漫热播',
    tag: '都市爱情',
    desc: '年度最甜都市爱情剧，高颜值主演阵容，讲述跨越星际的浪漫邂逅。全网播放量突破5亿，口碑持续飙升。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20scene%20with%20a%20couple%20silhouetted%20against%20a%20beautiful%20starry%20night%20sky%20with%20city%20lights%20in%20the%20distance%2C%20warm%20golden%20and%20soft%20pink%20color%20palette%2C%20dreamy%20cinematic%20atmosphere%2C%20Korean%20drama%20aesthetic%20with%20soft%20focus%20and%20gentle%20bokeh%20effects%2C%20emotional%20and%20tender%20mood&width=800&height=500&seq=carousel-2-91movie&orientation=landscape',
    alt: '星河恋人专题推荐',
  },
  {
    title: '《地球脉动III》纪录巨制',
    tag: '自然纪录',
    desc: 'BBC级制作水准，4K超高清拍摄全球珍稀生态景观，从深海到雪域，带你领略地球最震撼的生命奇迹。',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20landscape%20photography%20of%20a%20pristine%20mountain%20range%20with%20golden%20sunrise%20light%20illuminating%20snow-capped%20peaks%2C%20dramatic%20clouds%20rolling%20through%20valleys%2C%20rich%20natural%20color%20palette%20of%20deep%20greens%20and%20warm%20golden%20light%2C%20epic%20scale%20and%20grandeur%2C%20documentary-style%20cinematography%20with%20wide%20aspect%20ratio&width=800&height=500&seq=carousel-3-91movie&orientation=landscape',
    alt: '地球脉动纪录专题',
  },
  {
    title: '《星辰变》国漫新番',
    tag: '动画番剧',
    desc: '顶级国漫IP改编，精良制作媲美电影级画面。修仙世界的宏大叙事，每周五准时更新，追番不容错过。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20style%20scene%20with%20a%20warrior%20figure%20in%20flowing%20robes%20standing%20on%20a%20floating%20celestial%20mountain%20peak%2C%20surrounded%20by%20swirling%20energy%20and%20dramatic%20clouds%2C%20rich%20traditional%20Chinese%20art%20aesthetic%20with%20vibrant%20jade%20green%20and%20warm%20gold%20accents%2C%20cinematic%20lighting%20and%20epic%20composition&width=800&height=500&seq=carousel-4-91movie&orientation=landscape',
    alt: '星辰变国漫推荐',
  },
  {
    title: '《笑傲江湖》综艺热播',
    tag: '综艺娱乐',
    desc: '今夏最火爆喜剧竞演综艺，新老喜剧人同台PK，笑点密集全程无尿点。每周六晚八点欢乐上线。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20performance%20with%20colorful%20theatrical%20lighting%20in%20red%20and%20gold%20tones%2C%20multiple%20performers%20on%20a%20grand%20stage%20with%20audience%20silhouettes%20in%20the%20foreground%2C%20variety%20show%20atmosphere%20with%20dynamic%20spotlights%20and%20confetti%2C%20energetic%20and%20celebratory%20mood%2C%20wide%20stage%20composition%20capturing%20the%20grandeur&width=800&height=500&seq=carousel-5-91movie&orientation=landscape',
    alt: '笑傲江湖综艺推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              焦点专题推荐
            </h2>
            <p className="text-sm text-foreground-600">本周精选内容，不容错过</p>
          </div>
          <span className="hidden md:inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {features.map((f) => (
            <div key={f.title} className="group bg-white rounded-2xl overflow-hidden border border-secondary-100 transition-all hover:border-primary-200">
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={f.img}
                  alt={f.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-black/50 text-white backdrop-blur-sm whitespace-nowrap">
                  {f.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug">{f.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}